import * as yup from 'yup';
import { requiredImageFromCMSSchema } from '../schemas';

export const schema = yup
  .object({
    sectionTitle: yup.string(),
    image: requiredImageFromCMSSchema,
    title: yup.string(),
    description: yup.string(),
    buttonText: yup.string(),
    buttonVariant: yup.string(),
    bannerBackgroundColor: yup.string(),
  })
  .transform(value => ({
    sectionTitle: value.section_title,
    image: value.image,
    title: value.title,
    description: value.description,
    buttonText: value.button_text,
    buttonVariant: value.button_variant,
    bannerBackgroundColor: value.banner_background_color,
  }));
